module.exports = __webpack_public_path__ + "static/media/download_img_4.7c20328c.jpg";